import { render } from "./InsuranceCompaniesAdd.vue?vue&type=template&id=c43da308&scoped=true"
import script from "./InsuranceCompaniesAdd.vue?vue&type=script&lang=js"
export * from "./InsuranceCompaniesAdd.vue?vue&type=script&lang=js"

import "./InsuranceCompaniesAdd.vue?vue&type=style&index=0&id=c43da308&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c43da308"]])

export default __exports__